import { Checkbox } from '@paypalcorp/pp-react'
import React, { useEffect } from 'react'
import { trackClick, trackError } from 'ppbl/utils/fpti-helper'

const CheckboxAdapter = ({ input, meta, fptiPage, ...rest }) => {
  const handleChange = (event) => {
    input.onChange(event.target?.checked)
    trackClick({
      page: fptiPage,
      component: input.name,
      link: input.name,
    })
  }

  useEffect(() => {
    if (meta.touched && meta.error) {
      trackError({
        page: fptiPage,
        error: meta.error,
        component: input.name,
        link: input.name,
      })
    }
  }, [meta.error, meta.touched])

  return (
    <Checkbox
      {...rest}
      onChange={handleChange}
      error={meta.touched ? !!meta.error : false}
      errorText={meta.touched ? meta.error : ''}
    />
  )
}

export default CheckboxAdapter
